import React from 'react';
import Layout from '../components/Layout';




import ScrollingText from '../components/lettersslider';
import ServiceComponent from '../components/servicedescrpition';
import ComponentWithCards from '../components/serviceheadings';
import OurService from '../components/servicepage/ourservice';
import ContactForm from '../components/servicecontact';
import Coursework from '../components/courseworkheader';
import CourseworkServices from '../components/courseworkservice';
import DataHeader from '../components/dataheader';
import DataServices from '../components/dataservice';
import useScrollTransition from '../useScrollTransition';


const DataAnalysispage = () => {
  useScrollTransition();
  return (
    <Layout>
      
        <DataHeader/>
        <ScrollingText/>
        <DataServices/>
        <ServiceComponent/>
      <ComponentWithCards/>
      <OurService/>
      <ContactForm/>
        
    </Layout>
  );
};

export default DataAnalysispage;